import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// ** MUI Components
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// ** Demo Imports
import FooterIllustrations from 'src/views/pages/misc/FooterIllustrations'

// ** Styled Components
const BoxWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '90vw'
  }
}))

const Img = styled('img')(({ theme }) => ({
  marginBottom: theme.spacing(10),
  [theme.breakpoints.down('lg')]: {
    height: 450,
    marginTop: theme.spacing(10)
  },
  [theme.breakpoints.down('md')]: {
    height: 400
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: theme.spacing(13)
  }
}))

const Error401 = () => {
  const { t } = useTranslation()

  return (
    <Box className='content-center'>
      <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <BoxWrapper>
          <Typography variant='h1'>401</Typography>
          <Typography variant='h5' sx={{ mb: 1, fontSize: '1.5rem !important' }}>
            {t('errors.401.heading')}
          </Typography>
          <Typography variant='body2'>{t('errors.401.message')}</Typography>
        </BoxWrapper>
        {/* <Img height='487' alt='error-illustration' src='/images/pages/401.png' /> */}
        <Button to='/' component={Link} variant='contained' sx={{ px: 5.5, my: 5 }}>
          {t('common.backToHome')}
        </Button>
      </Box>
      {/* <FooterIllustrations /> */}
    </Box>
  )
}

export default Error401
